import { APIGET } from "@/util/http"

export function getUserInfo () {
    return APIGET ('user/info')
}


export function getMenusList () {
    return APIGET (`user/menusList`)
}
